import React, { lazy, useCallback, useRef, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Select = lazy(() => import(`globalcomponents/UI/Select/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));

const MainFilter = React.memo(({ onChange }) => {
    const { t } = useTranslation();

    const defaultFilter = useMemo(() => [
        { label: t('newScoreCard.last30Days'), value: 'MONTHLY' },
        { label: t('newScoreCard.currentPolicyPeriod'), value: 'YEARLY' },
    ], [t]);

    const selectRef = useRef(null);
    const [value, setValue] = useState(defaultFilter[0]);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const handleChange = useCallback((selectedOption) => {
        if (selectedOption === value) return;
        setValue(selectedOption);
        onChange(selectedOption);
        setMenuIsOpen(false);
    }, [value, onChange]);

    const toggleMenu = () => {
        setMenuIsOpen((prev) => !prev);
        if (selectRef.current) {
            selectRef.current.focus();
        }
    };

    return (
        <FormStyle.default.FieldsWrapper className="horizontal" onClick={toggleMenu}>
            <Label variant="body1" htmlFor="severityId">
                {t('newScoreCard.selectPeriod')}
            </Label>
            <FormStyle.default.TextWrapper>
                <Select
                    ref={selectRef}
                    menuIsOpen={menuIsOpen}
                    onMenuClose={() => setMenuIsOpen(false)}
                    id="severityId"
                    className="choose-period"
                    value={value}
                    onChange={handleChange}
                    placeholder={t('common.pleaseSelect')}
                    suggestions={defaultFilter}
                />
            </FormStyle.default.TextWrapper>
        </FormStyle.default.FieldsWrapper>
    );
});

MainFilter.propTypes = {
    onChange: PropTypes.func,
};

MainFilter.defaultProps = {
    onChange: () => { },
};

export default MainFilter;